import {
	Box,
	Button,
	Flex,
	Grid,
	Modal,
	ModalBody,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Text,
	useDisclosure,
} from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import { FC, useState } from 'react';
import { isHexColor } from 'src/utils/utils';
import { SketchPicker } from 'react-color';
import { ExitCircleIcon } from 'src/utils/icons/exitCircle';

interface Props {
	name: string;
	label: string;
	hexColor: string;
	disabled?: boolean;
}

const sketchStyles: any = {
	picker: {
		background: 'transparent',
	},
};

export const ColorInput: FC<Props> = ({ name, label, hexColor, disabled }) => {
	const formikProps = useFormikContext();
	const { isOpen, onOpen, onClose } = useDisclosure();

	const [color, setColor] = useState<string>(hexColor);
	const [savedColor, setSavedColor] = useState<string>(hexColor);

	const handleChangeComplete = (newColor: string) => {
		setColor(newColor);
		formikProps.setFieldValue(name, newColor);
	};

	const handleClose = () => {
		onClose();
		setColor(savedColor);
		formikProps.setFieldValue(name, savedColor);
	};

	const handleOpen = () => {
		if (disabled) return;
		onOpen();
		setSavedColor(color);
	};

	const handleSave = () => {
		onClose();
		formikProps.setFieldValue(name, color);
	};

	return (
		<Grid
			templateRows="auto auto"
			alignItems="center"
			gridGap="10px"
			opacity={disabled ? 0.3 : 1}
		>
			<Modal
				isOpen={isOpen}
				onClose={handleClose}
			>
				<ModalOverlay />
				<ModalContent
					bg="field.addon"
					border="1px solid"
					borderColor="field.background"
					m="0 20px"
					color="black"
					alignSelf="center"
				>
					<ModalHeader
						display="flex"
						justifyContent="space-between"
						alignItems="center"
						color="white"
					>
						<Text
							fontWeight="bold"
							fontSize="20px"
						>
							{label}
						</Text>
						<ExitCircleIcon
							_hover={{ opacity: 0.7 }}
							maxW="20px"
							maxH="20px"
							onClick={handleClose}
						/>
					</ModalHeader>
					<ModalBody
						alignItems="center"
						justifyContent="flex-end"
						css={{
							label: {
								color: 'white !important',
								fontWeight: '600',
							},
							'.flexbox-fix': {
								border: 'none !important',
							},
						}}
					>
						<SketchPicker
							styles={sketchStyles}
							width="auto"
							color={color}
							onChange={value => handleChangeComplete(value.hex)}
						/>
						<Flex
							justifyContent="flex-end"
							m="15px 0px"
						>
							<Button
								onClick={handleSave}
								variant="sharp"
							>
								SAVE
							</Button>
						</Flex>
					</ModalBody>
				</ModalContent>
			</Modal>
			<Text>{label}</Text>
			<Box
				bg={isHexColor(hexColor) ? hexColor : 'transparent'}
				border={`1px solid ${isHexColor(hexColor) ? 'transparent' : 'gray'}`}
				height="40px"
				borderRadius="6px"
				onClick={handleOpen}
				_hover={{ opacity: disabled ? 1 : 0.7 }}
				cursor={disabled ? 'default' : 'pointer'}
			/>
		</Grid>
	);
};
